<template>
  <div id="dashboard">
    <header id="dashboard-header">
      <section
        id="dashboard-header__blocks"
        v-if="isBlockedGlobal.length || isBlockedForCustomer.length"
      >
        <InfoBox
          :is-warning="true"
          :is-severe="Object.keys(userIsBlockedGlobal).length > 0"
          :header="$t('headings.USER_IS_BLOCKED')"
          :content="isBlockedGlobal || isBlockedForCustomer"
        />
      </section>
    </header>
    <section id="comments-latest-user">
      <list
        :heading="$t('headings.COMMENTS_RECENT_USER')"
        :items="myComments"
        :placeholders="latestCommentsUserPlaceholder(5)"
        :empty="'placeholders.NO_COMMENTS'"
      >
        <template v-slot:page-link>
          <router-link
            class="copy link"
            :to="{ path: 'comments', query: { pageSize: 10, offset: 0 } }"
          >
            {{ $t("headings.LINK_COMMENTS_RECENT_USER") }}
          </router-link>
        </template>
        <template v-slot:item="{ item }">
          <comment
            :key="item.id"
            :comment="item"
          />
        </template>
      </list>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatDate } from "@/helpers/functions";
import Comment from "../components/global/Comment";
import InfoBox from "../components/global/InfoBox";
import List from "../components/global/List";
import SkeletonPost from "../components/global/SkeletonPost";

export default {
  name: "Dashboard",
  components: {
    Comment,
    InfoBox,
    List,
  },
  created() {
    this.getMyComments({ size: 5, offset: 0, sorting: "" });
  },
  computed: {
    ...mapGetters([
      "myComments",
      "myProfile",
      "userIsBlockedGlobal",
      "aliasIsBlockedGlobal",
      "userBlocks",
      "aliasBlocks",
    ]),
    isBlockedForCustomer() {
      let str = "";
      if (this.userBlocks.length) {
        const list = this.buildCustomerList(this.userBlocks);
        str += this.$t("block.USER_CUSTOMER", {
          sites: list,
        });
      }
      if (this.userBlocks.length && this.aliasBlocks.length) str += "<br>";
      if (this.aliasBlocks.length) {
        const list = this.buildCustomerList(this.aliasBlocks);
        str += this.$t("block.ALIAS_CUSTOMER", {
          sites: list,
        });
      }
      if (this.userBlocks.length || this.aliasBlocks.length)
        str += `<br>${this.$t("block.COMMENTING_AVAILABLE")}`;
      return str;
    },
    isBlockedGlobal() {
      if (Object.keys(this.userIsBlockedGlobal).length) {
        const ts = this.setBlockTimeStamp(this.userIsBlockedGlobal.duration);
        return this.$t("block.USER_GLOBAL", {
          time: ts,
        });
      }
      if (Object.keys(this.aliasIsBlockedGlobal).length) {
        const ts = this.setBlockTimeStamp(this.aliasIsBlockedGlobal.duration);
        return this.$t("block.ALIAS_GLOBAL", {
          time: ts,
        });
      }
      return "";
    },
  },
  methods: {
    ...mapActions(["getMyComments"]),
    buildCustomerList(blocks) {
      let customerList = "";
      for (const block of blocks) {
        const ts = this.setBlockTimeStamp(block.duration);
        customerList += `<li>${block.customer} (${ts})</li>`;
      }
      return customerList;
    },
    setBlockTimeStamp(duration) {
      // Check if the block has a duration. If it does, return e.g. "until July 12 2022", else return "indefinitely"
      return duration.length
        ? this.$t("timestamps.UNTIL", { date: formatDate(duration) })
        : this.$t("timestamps.INDEFINITELY");
    },
    latestCommentsUserPlaceholder(count) {
      return {
        count,
        component: SkeletonPost,
      };
    },
  },
};
</script>
